import { Component, OnInit } from '@angular/core';
import { ModalService } from '@frogo-kit/core';
import { FormControl, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { UserInfo } from '../../auth/store/models/user-info.interface';
import * as AuthSelectors from '../../auth/store/selectors/auth.selector';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as AuthActions from '../../auth/store/actions/auth.actions';
import { Observable } from 'rxjs';
import { PermissionsService } from '../../services/permissions.service';
import { FeatureName, featurePermissions } from '../../permissions/feature-permissions';
import { SharedOrganization } from '../../auth/store/models/shared-organization.interface';
import { map } from 'rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'aft-profile',
    templateUrl: './profile.component.html',
    styleUrl: './profile.component.scss',
    standalone: false,
})
export class ProfileComponent implements OnInit {
  public title: string = '';
  public userNameControl = new FormControl('', [Validators.required]);
  public userInfo: UserInfo;
  public selectedOrgId: string;
  public toggleOrganizationList = false;
  public baseOrganizationVisibleLength = 5;
  public updateProfileDataLoading$: Observable<boolean> = this._store.select(AuthSelectors.updateProfileDataLoading);
  public canUpdateData = false;
  public sharedOrganizations$: Observable<SharedOrganization[]>
    = this._store.select(AuthSelectors.sharedOrgsSelector)
    .pipe(
      map(res => res.shared),
    );
  private _canUpdateData$: Observable<boolean> = this._permissionsService.hasPermission$(featurePermissions.get(FeatureName.UMUserWrite));


  constructor(
    private readonly _modal: ModalService,
    private readonly _store: Store,
    private _permissionsService: PermissionsService,
  ) {}

  public ngOnInit(): void {
    this._store.select(AuthSelectors.userDataSelector).pipe(untilDestroyed(this)).subscribe(userInfo => {
      this.userInfo = userInfo.userData;
      this.selectedOrgId = userInfo.orgInfo.id;
      this.userNameControl.setValue(this.userInfo.name);
    });

    this._canUpdateData$.pipe(untilDestroyed(this)).subscribe(isCanUpdate => {
      if ( !isCanUpdate ) {
        this.userNameControl.disable();
      }
      this.canUpdateData = isCanUpdate;
    })
  }

  public onCloseModal() {
    this._modal.hide();
  }

  public updateUserProfile(): void {
    if ( this.userNameControl.valid ) {
      this._store.dispatch(AuthActions.updateProfile({
        id: this.userInfo.id,
        data: {
          name: this.userNameControl.value,
          role: this.userInfo.role,
        },
      }));
      this._modal.hide();
    }
  }

  protected getShortenedName(source: string): string {
    return source
      .split(' ')
      .slice(0, 2)
      .map(word => word[0])
      .join('');
  }
}
